export default __webpack_public_path__ + "static/media/05-main.7f236ed0.jpg";